import React from 'react';
import Layout, { Content } from 'antd/lib/layout/layout';

function LayoutLogin(props) {
  const { children } = props;
  return (
    <Layout className="layout-login-admin welcome min-h-screen">
      {/* <SquareBackground /> */}
      <Content className="layout-login-admin__content">{children}</Content>
    </Layout>
  );
}

export default LayoutLogin;
